import { useEffect } from 'react';

function setMeta(property, content, isName = false) {
  const attr = isName ? `name="${property}"` : `property="${property}"`;
  let el = document.querySelector(`meta[${attr}]`);
  if (!el) {
    el = document.createElement('meta');
    if (isName) el.setAttribute('name', property);
    else el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export function useDocumentTitle(title, retainOnUnmount = false) {
  useEffect(() => {
    const originalTitle = document.title;
    document.title = title;
    return () => {
      if (!retainOnUnmount) document.title = originalTitle;
    };
  }, [title, retainOnUnmount]);
}

export function usePageMeta({ title, description, image } = {}) {
  useEffect(() => {
    const originalTitle = document.title;
    const originalDesc = document.querySelector('meta[name="description"]')?.getAttribute('content');
    const originalOgTitle = document.querySelector('meta[property="og:title"]')?.getAttribute('content');
    const originalOgDesc = document.querySelector('meta[property="og:description"]')?.getAttribute('content');
    const originalOgImage = document.querySelector('meta[property="og:image"]')?.getAttribute('content');
    const originalTwTitle = document.querySelector('meta[name="twitter:title"]')?.getAttribute('content');
    const originalTwDesc = document.querySelector('meta[name="twitter:description"]')?.getAttribute('content');
    const originalTwImage = document.querySelector('meta[name="twitter:image"]')?.getAttribute('content');

    if (title) {
      document.title = title;
      setMeta('og:title', title);
      setMeta('twitter:title', title, true);
    }
    if (description) {
      setMeta('description', description, true);
      setMeta('og:description', description);
      setMeta('twitter:description', description, true);
    }
    if (image) {
      setMeta('og:image', image);
      setMeta('twitter:image', image, true);
      setMeta('twitter:card', 'summary_large_image', true);
    }
    setMeta('og:url', window.location.href);

    return () => {
      if (originalTitle) document.title = originalTitle;
      if (originalDesc) setMeta('description', originalDesc, true);
      if (originalOgTitle) setMeta('og:title', originalOgTitle);
      if (originalOgDesc) setMeta('og:description', originalOgDesc);
      if (originalOgImage) setMeta('og:image', originalOgImage);
      if (originalTwTitle) setMeta('twitter:title', originalTwTitle, true);
      if (originalTwDesc) setMeta('twitter:description', originalTwDesc, true);
      if (originalTwImage) setMeta('twitter:image', originalTwImage, true);
    };
  }, [title, description, image]);
}
